import api from "../api";
import { toast } from 'vue3-toastify'

export default {
  namespaced: true,
  state: {
    featureds: {},
    featured: {},
    featuredAd_by_store: {},
    pending_featuredAd_by_store: {},
    active_featuredAd_by_store: {},
    positionDate: {},
    ads: {},
    bra_center_featureds: []
  },
  getters: {

  },
  actions: {

    async get_featureds({ commit }) {
      try {
        api.get("/v1/featureds")
          .then((res) => {
            commit("GET_FEATUREDS", res.data);
          })
          .catch((error) => {
            commit("ERROR_FEATURED", "Erro ao carregar os destaques");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_FEATURED", e);
      }
    },

    async delete_featured({ commit }, id) {
      try {
        api.delete(`/v1/featured-ad/delete/${id}`)
          .then((res) => {

            if (res?.data?.error) {
              console.log(res?.data)

              toast.warning(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });

            } else {
              if (res?.data) {
                commit("GET_PENDING_AD_FEATUREDS", res.data.result);
              }
            }

          })
          .catch((error) => {
            commit("ERROR_FEATURED", "Erro ao carregar os destaques");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_FEATURED", e);
      }
    },

    async get_ads({ commit }, store_id) {
      try {
        api.get(`/v1/ad-featured/${store_id}`)
          .then((res) => {
            commit("GET_ADS", res.data);
          })
          .catch((error) => {
            commit("ERROR_AD", "Erro ao carregar as ads");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_AD", e);
      }
    },

    async get_featuredAd_by_store({ commit }, payload) {
      try {
        api.get(`/v1/featured-ad/${payload?.store_id}/${payload?.status}`)
          .then((res) => {

            if (res?.data?.error) {
              console.log(res?.data)

              toast.warning(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });

            } else {
              if (res?.data) {
                switch (payload?.status) {
                  case "pending":
                    commit("GET_PENDING_AD_FEATUREDS", res.data.result);
                    break;
                  case "active":
                    commit("GET_ACTIVE_AD_FEATUREDS", res.data.result);
                    break;
                  default:
                    commit("GET_AD_FEATUREDS", res.data.result);
                    break;
                }
              }
            }

          })
          .catch((error) => {
            commit("ERROR_AD_FEATURED", "Erro ao carregar os destaques");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_FEATURED", e);
      }
    },

    async dates_by_position({ commit }, position) {
      try {
        api.get(`/v1/date-position/${position}`)
          .then((res) => {
            commit("GET_DATE_POSITION", res.data);
          })
          .catch((error) => {
            commit("ERROR_DATE_POSITION", "Erro ao carregar as posições");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_DATE_POSITION", e);
      }
    },

    async create_featureds({ dispatch, commit }, payload = []) {
      try {
        return api.post("/v1/create-featured", payload)
          .then((res) => {

            if (res?.data?.error) {
              console.log(res?.data)

              toast.warning(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });

            } else {
              if (res?.data) {
                commit("GET_PENDING_AD_FEATUREDS", res.data.result);
                toast.success(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              }
            }
            return res.data

          })
          .catch((error) => {
            commit("ERROR_ADD_FEATURED", "Erro ao carregar os destaques");
            //dispatch("alert/set_alert", {alert_message: error.response.data.message, type_message: 'alert-warning'}, { root: true });

            //if (window.innerWidth < 480) {
            toast.warning(error.response.data.message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            //}

          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ADD_FEATURED", e);
      }
    },

    async update_featureds({ dispatch, commit }, payload = []) {
      try {
        api.post("/v1/update-featured", payload)
          .then((res) => {
            commit("GET_AD_FEATUREDS", res.data);
            //dispatch("alert/set_alert", {alert_message: "Atualizado com sucesso!", type_message: 'alert-success'}, { root: true });

            //if (window.innerWidth < 480) {
            toast.success("Atualizado com sucesso!", {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            //}

          })
          .catch((error) => {
            commit("ERROR_UPT_FEATURED", error);
            //dispatch("alert/set_alert", {alert_message: error.response.data.message, type_message: 'alert-warning'}, { root: true });

            //if (window.innerWidth < 480) {
            toast.warning(error.response.data.message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            //}

          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_UPT_FEATURED", e);
      }
    },

    async get_product_bra_center_featureds({ commit }) {
      try {
        api.get(`/v1/bra-center-featured`)
          .then((res) => {
            commit("GET_BRA_CENTER_FEATURED", res.data);
          })
          .catch((error) => {
            commit("ERROR_BRA_CENTER_FEATURED", "Erro ao carregar as posições");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_BRA_CENTER_FEATURED", e);
      }
    },

    async save_order({ commit }, payload) {
      try {
        return api.post("/v1/featured-ad/save-order", payload)
          .then((res) => {
            if (res?.data?.error) {
              console.log(res?.data)

              toast.warning(res?.data?.message, {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });

            } else {
              if (res?.data) {
                toast.success(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              }
            }
            return res.data
          })
          .catch((error) => {
            commit("ERROR_FEATURED", error);
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_FEATURED", e);
        //dispatch("alert/set_alert", {alert_message: "Algo deu errado! Tente novamente mais tarde", type_message: 'alert-warning'}, { root: true });

        //if (window.innerWidth < 480) {
        toast.warning(e, {
          type: 'default',
          theme: 'colored',
          hideProgressBar: true,
          dangerouslyHTMLString: true
        });
        //}
      }
    },

  },
  mutations: {

    GET_FEATUREDS(state, data) {
      state.featureds = data
    },
    ERROR_FEATURED(state, data) {
      console.log(data)
    },

    GET_AD_FEATUREDS(state, data) {
      state.featuredAd_by_store = data
    },

    GET_PENDING_AD_FEATUREDS(state, data) {
      state.pending_featuredAd_by_store = data
    },

    GET_ACTIVE_AD_FEATUREDS(state, data) {
      state.active_featuredAd_by_store = data
    },

    ERROR_AD_FEATURED(state, data) {
      console.log(data)
    },

    GET_ADD_FEATUREDS(state, data) {
      state.featured = data
    },
    ERROR_ADD_FEATURED(state, data) {
      console.log(data)
    },

    GET_UPT_FEATUREDS(state, data) {
      state.featured = data
    },
    ERROR_UPT_FEATURED(state, data) {
      console.log(data)
    },

    GET_DATE_POSITION(state, data) {
      state.positionDate = data
    },
    ERROR_DATE_POSITION(state, data) {
      console.log(data)
    },

    GET_ADS(state, data) {
      state.ads = data;
    },
    ERROR_AD(state, data) {
      console.log(data)
    },

    GET_BRA_CENTER_FEATURED(state, data) {
      state.bra_center_featureds = data;
    },
    ERROR_BRA_CENTER_FEATURED(state, data) {
      console.log(data)
    },
  }
}